import type { Dispatch, UnknownAction } from '@reduxjs/toolkit'
import { useEffect } from 'react'

import { accessPruned, type CashierAccessState } from './cashierAccessSlice'

/** Ближайший срок, когда подтверждение кода истечёт или блокировка снимется (мс); `null` — следить не за чем. */
export function nextAccessExpiry(state: Pick<CashierAccessState, 'proofs' | 'locks'>): number | null {
  const times = [...Object.values(state.proofs).map((item) => item.expiresAt), ...Object.values(state.locks)]
    .map((iso) => Date.parse(iso))
    .filter((time) => Number.isFinite(time))
  return times.length === 0 ? null : Math.min(...times)
}

/**
 * Подтверждение кода живёт не дольше срока службы (≤ 10 минут), блокировка — ровно до её окончания. В нужный момент
 * просроченное снимается из состояния: блок «Код» открывается снова, не дожидаясь нажатия «Открыть смену».
 */
export function useAccessExpiry(access: CashierAccessState, dispatch: Dispatch<UnknownAction>): void {
  const at = nextAccessExpiry(access)
  useEffect(() => {
    if (at === null) return undefined
    const timer = setTimeout(() => dispatch(accessPruned({ now: Date.now() })), Math.max(0, at - Date.now()) + 50)
    return () => clearTimeout(timer)
  }, [at, dispatch])
}
